import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'save-button-tvd',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.scss'],
    standalone: false
})
export class SaveButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
